import React, { useState, useEffect } from 'react';
import api from '../services/api';

const AnnouncementBanner = () => {
    const [bannerData, setBannerData] = useState({
        isActive: true,
        text: 'Book your seat! Sale is live: ',
        highlightText: '30% OFF',
        link: ''
    });

    useEffect(() => {
        const fetchBannerData = async () => {
            try {
                // Assuming you have an endpoint for this. We use a generic one based on our setup.
                const response = await api.get('/announcement');
                if (response.success && response.data) {
                    setBannerData(response.data);
                }
            } catch (error) {
                console.error('Error fetching announcement banner:', error);
            }
        };

        fetchBannerData();
    }, []);

    if (!bannerData.isActive) {
        return null;
    }

    const content = (
        <span className="flex items-center gap-1.5">
            <span className="text-sm not-italic">🔥</span>
            {bannerData.text}
            {bannerData.highlightText && (
                <span className="font-bold not-italic bg-black text-brand-gold px-1.5 py-0 rounded-sm leading-tight">
                    {bannerData.highlightText}
                </span>
            )}
        </span>
    );

    return (
        <div className="bg-brand-gold py-0.5 overflow-hidden relative shadow-md z-40 border-y border-brand-goldHover">
            <div className="flex w-max animate-scroll whitespace-nowrap items-center text-xs md:text-sm font-medium italic text-black tracking-wide" style={{ animationDuration: '26s' }}>
                {/* Duplicate the list to ensure seamless scrolling */}
                {[...Array(20)].map((_, i) => (
                    <span key={i} className="mx-8">
                        {bannerData.link ? (
                            <a href={bannerData.link} target="_blank" rel="noopener noreferrer" className="hover:opacity-80 transition-opacity">
                                {content}
                            </a>
                        ) : (
                            content
                        )}
                    </span>
                ))}
            </div>
        </div>
    );
};

export default AnnouncementBanner;
